/** Aproxima um círculo WGS84 (raio em metros) como Polygon GeoJSON. */
export function bufferPointGeoJSON(lat, lon, radiusM = 50, steps = 16) {
  const r = 6371000;
  const latR = (Number(lat) * Math.PI) / 180;
  const ring = [];
  for (let i = 0; i < steps; i += 1) {
    const brng = (2 * Math.PI * i) / steps;
    const ang = radiusM / r;
    const lat2 = Math.asin(
      Math.sin(latR) * Math.cos(ang) + Math.cos(latR) * Math.sin(ang) * Math.cos(brng),
    );
    const lon2 =
      (Number(lon) * Math.PI) / 180 +
      Math.atan2(
        Math.sin(brng) * Math.sin(ang) * Math.cos(latR),
        Math.cos(ang) - Math.sin(latR) * Math.sin(lat2),
      );
    ring.push([(lon2 * 180) / Math.PI, (lat2 * 180) / Math.PI]);
  }
  ring.push(ring[0]);
  return { type: 'Polygon', coordinates: [ring] };
}

export function stringifyGeoJSON(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return '';
  }
}

export function parseGeoJSONInput(value) {
  if (value == null || String(value).trim() === '') return null;
  if (typeof value === 'object') return value;
  return JSON.parse(String(value));
}
